import { create } from "zustand";

type TrackWalletConnectStore = {
  userInitiatedLogin: boolean;
  setUserInitiatedLogin: (value: boolean) => void;
  isNewUser: boolean | null;
  setIsNewUser: (value: boolean | null) => void;
};

export const useTrackWalletConnectStore = create<TrackWalletConnectStore>((set) => ({
  userInitiatedLogin: false,
  setUserInitiatedLogin: (value) => set({ userInitiatedLogin: value }),
  isNewUser: null,
  setIsNewUser: (value) => set({ isNewUser: value }),
}));
